module.exports = __webpack_public_path__ + "img/1506247097.02020078.jpg";